import React from 'react';

export default function VerticalPaddedContainer({children}) {
  return <div className="container py-2 py-md-3 d-flex">{children}</div>;
}

export function VerticalPaddedContainerFluid({children}) {
  return <div className="container-fluid py-2 py-md-3 d-flex">{children}</div>;
}
